module.exports = __webpack_public_path__ + "static/media/icon_a.237958af.png";